import type { IconRootProps } from './Root'
import { IconRoot } from './Root'

export const PlusInCircleIcon = ({ size = '1.5rem', ...props }: IconRootProps) => {
  return (
    <IconRoot viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" size={size} {...props}>
      <circle cx="12" cy="12" r="8.75" stroke="currentColor" strokeWidth="1.5" fill="none" />
      <path d="M12 7V17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M17 12L7 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </IconRoot>
  )
}
